import { Asset, Media } from '@gripp/shared-logic';
import { MediaListItem } from '@gripp/shared-ui';
import { AssetFileItemMenu } from './assetFileItemMenu';

type Props = {
  asset?: Asset;
  media: Media;
  invalidateQuery: () => void;
  isFromProduct?: boolean;
  disabled?: boolean;
};

export const AssetFileItem = ({
  asset,
  media,
  invalidateQuery,
  isFromProduct,
  disabled,
}: Props) => {
  return (
    <MediaListItem
      media={media}
      invalidateQuery={invalidateQuery}
      menu={
        asset && !isFromProduct ? (
          <AssetFileItemMenu
            asset={asset}
            media={media}
            invalidateQuery={invalidateQuery}
            disabled={disabled}
          />
        ) : undefined
      }
    />
  );
};
